import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/img/icon-arrow-right-active.svg'


const _hoisted_1 = {
  key: 0,
  class: "title"
}
const _hoisted_2 = {
  key: 1,
  class: "description"
}
const _hoisted_3 = { class: "widget-main" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = ["swidth", "onClick"]
const _hoisted_6 = {
  key: 1,
  class: "no-results"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableCell = _resolveComponent("TableCell")!
  const _component_TableList = _resolveComponent("TableList")!
  const _component_widget_layout = _resolveComponent("widget-layout")!

  return (_openBlock(), _createBlock(_component_widget_layout, {
    class: _normalizeClass(["user-generic", `width${_ctx.width}`]),
    minHeight: 2,
    maxHeight: 2,
    maxWidth: 2,
    loading: !_ctx.data,
    menuColour: "#fff"
  }, {
    title: _withCtx(() => [
      (_ctx.userData?.widgetTitle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.userData.widgetTitle), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.userData?.widgetDescription)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("p", null, _toDisplayString(_ctx.userData.widgetDescription), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.usersData && _ctx.usersData.length)
            ? (_openBlock(), _createBlock(_component_TableList, {
                key: 0,
                tableName: "users",
                totalRows: _ctx.usersData ? _ctx.usersData.length : 0,
                currentPage: _ctx.currentPage,
                paginated: false,
                showTableSelection: false,
                customClass: "new-style no-top-border"
              }, {
                colspan: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("colgroup", null, [
                    _createElementVNode("col", { style: {"width":"15%"} }),
                    _createElementVNode("col", { style: {"width":"40%"} }),
                    _createElementVNode("col", { style: {"width":"30%"} }),
                    _createElementVNode("col", { style: {"width":"15%"} })
                  ], -1)
                ]))]),
                head: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, " "),
                      _createElementVNode("th", { class: "text-left" }, "User"),
                      _createElementVNode("th", null, "Start Date"),
                      _createElementVNode("th", null, " ")
                    ])
                  ], -1)
                ]))]),
                body: _withCtx(() => [
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (row, i) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: row.id,
                        class: _normalizeClass(["row", {
                    alternate: _ctx.isOdd(i),
                  }])
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.cols, (col) => {
                          return (_openBlock(), _createBlock(_component_TableCell, {
                            dataType: col.dataType,
                            data: col.data,
                            dataInfo: col.dataInfo,
                            key: col.id,
                            onClickCell: ($event: any) => (_ctx.handleClickCell(row.id, row.rowId)),
                            onClickRow: ($event: any) => (_ctx.handleClickCell(row.id, row.rowId))
                          }, null, 8, ["dataType", "data", "dataInfo", "onClickCell", "onClickRow"]))
                        }), 128)),
                        _createElementVNode("td", {
                          class: "td-button",
                          swidth: 100 / (row.cols.length + 1) + '%',
                          onClick: ($event: any) => (_ctx.handleClickCell(row.id, row.rowId))
                        }, [...(_cache[2] || (_cache[2] = [
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: "",
                            style: {"height":"14px","width":"7px"}
                          }, null, -1)
                        ]))], 8, _hoisted_5)
                      ], 2))
                    }), 128))
                  ])
                ]),
                _: 1
              }, 8, ["totalRows", "currentPage"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, " There are no users currently matching this criteria "))
        ])
      ])
    ]),
    _: 1
  }, 8, ["loading", "class"]))
}